import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import { CardItemIcon, CardSubtitle, CardTitle } from '@/components/Card'
import { type IconName } from '@/components/Icon'
import {
  ExpandableCardListItem,
  ExpandableCardListItemContent,
  ExpandableCardListItemPanel,
} from '@/components/ExpandableCardList'
import styles from './StepCardListItemContainer.module.css'

interface StepCardListItemContainerProps {
  icon: IconName
  title: ReactNode
  subtitle: ReactNode
  extras?: ReactNode
  isExpanded: boolean
  onExpandedChange: (isExpanded: boolean) => void
  children: ReactNode
  testId?: string
}

export const StepCardListItemContainer = observer(
  function StepCardListItemContainer({
    icon,
    title,
    subtitle,
    extras,
    isExpanded,
    onExpandedChange,
    children,
    testId,
  }: StepCardListItemContainerProps) {
    return (
      <ExpandableCardListItem
        isExpanded={isExpanded}
        onExpandedChange={onExpandedChange}
        testId={testId}
      >
        <ExpandableCardListItemContent
          icon={<CardItemIcon name={icon} />}
          align="center"
          extras={extras}
          testId={testId ? `${testId}-header` : undefined}
        >
          <CardTitle>{title}</CardTitle>
          <CardSubtitle variant="sm">{subtitle}</CardSubtitle>
        </ExpandableCardListItemContent>
        <ExpandableCardListItemPanel>
          <StepCardListItemPanelContent>
            {children}
          </StepCardListItemPanelContent>
        </ExpandableCardListItemPanel>
      </ExpandableCardListItem>
    )
  },
)

function StepCardListItemPanelContent({ children }: { children: ReactNode }) {
  return <div className={styles.content}>{children}</div>
}
